<template>
  <div class="poi__icon" :class="{ vendor: selectedPoi.logo }">
    <ion-img :src="getCustomMarkerIcon(selectedPoi)" />
  </div>
  <p class="poi__type">{{ poiType }}</p>
  <div class="scroll">
    <div class="poi__header">
      <div class="poi__header__button" @click="goToEdit" v-if="selectedPoi.company_id === null">
        <svg width="28.15" height="28.15" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.19057 17.3411C2.19167 17.1585 2.22924 17.0454 2.29295 16.9391C2.70839 16.2468 3.12296 15.5538 3.5395 14.8621C3.56432 14.821 3.56388 14.7917 3.54257 14.7497C3.35056 14.3726 3.18908 13.9825 3.06166 13.5788C3.0476 13.5344 3.02629 13.5133 2.97972 13.5014C2.18222 13.3005 1.38539 13.0977 0.588556 12.8946C0.316794 12.8253 0.125439 12.5805 0.125 12.2982C0.123901 11.4499 0.123901 10.6016 0.125 9.75326C0.125439 9.47364 0.314377 9.22989 0.58548 9.16059C1.38034 8.95709 2.17563 8.7549 2.97115 8.5547C3.02343 8.5415 3.04782 8.51884 3.06386 8.4678C3.19084 8.06586 3.35188 7.67756 3.54323 7.30202C3.56366 7.26177 3.56432 7.23382 3.54082 7.19466C3.12647 6.50584 2.71367 5.81614 2.30042 5.12666C2.12269 4.82988 2.15806 4.53816 2.40236 4.29352C2.97972 3.71536 3.55685 3.1372 4.13421 2.55926C4.37566 2.31748 4.66917 2.28118 4.96202 2.45718C5.65055 2.87078 6.33929 3.2846 7.02715 3.6993C7.06516 3.72218 7.09394 3.72548 7.13502 3.70436C7.51641 3.50922 7.91143 3.34664 8.3194 3.21684C8.35807 3.20452 8.37366 3.18494 8.38245 3.1482C8.57754 2.33156 8.77373 1.51514 8.96948 0.698724C9.04154 0.398424 9.2966 0.195804 9.60571 0.195584C10.4401 0.195364 11.2747 0.195364 12.1091 0.195584C12.4161 0.195584 12.6702 0.395124 12.7425 0.694984C12.938 1.5059 13.1329 2.31704 13.3258 3.12862C13.3381 3.1801 13.359 3.20694 13.4106 3.223C13.8157 3.3506 14.2063 3.51428 14.5847 3.70722C14.6196 3.72504 14.6444 3.72394 14.678 3.7037C15.3677 3.28812 16.0579 2.87364 16.748 2.45916C17.045 2.28074 17.3357 2.31616 17.5798 2.56036C18.1584 3.13984 18.7369 3.7191 19.3156 4.29858C19.5542 4.5375 19.59 4.83164 19.4153 5.12292C19.0012 5.81394 18.5873 6.50518 18.1721 7.19554C18.1499 7.2325 18.149 7.26 18.1688 7.29873C18.3628 7.67888 18.5244 8.07268 18.6543 8.47946C18.6675 8.52061 18.6861 8.53996 18.7288 8.5503C19.5452 8.7494 20.3611 8.95048 21.1775 9.15047C21.4855 9.22592 21.6733 9.46331 21.6733 9.78187C21.6733 10.6121 21.6736 11.4424 21.6733 12.2725C21.6733 12.5884 21.4888 12.826 21.1819 12.9017C20.3672 13.1025 19.5524 13.3025 18.7373 13.5012C18.6897 13.5128 18.6664 13.5337 18.6514 13.5808C18.5227 13.988 18.3597 14.3812 18.1655 14.7613C18.1472 14.7972 18.1512 14.8223 18.1707 14.8548C18.5857 15.5454 18.9996 16.2367 19.4136 16.9277C19.5911 17.2238 19.5548 17.5162 19.3105 17.7606C18.7332 18.3388 18.156 18.9169 17.5787 19.4949C17.3372 19.7364 17.0444 19.7723 16.7509 19.5958C16.0606 19.1814 15.3703 18.7669 14.6809 18.3513C14.646 18.3302 14.6205 18.3278 14.5833 18.3467C14.2055 18.5405 13.8144 18.7031 13.4095 18.8311C13.3601 18.8467 13.3388 18.8718 13.3267 18.9211C13.1331 19.7065 12.938 20.4915 12.7425 21.2764C12.6676 21.5772 12.4156 21.7736 12.1074 21.7738C11.2747 21.7741 10.4419 21.7741 9.60923 21.7738C9.29836 21.7738 9.04483 21.5752 8.97014 21.274C8.77439 20.4855 8.57842 19.6968 8.38399 18.9081C8.3741 18.8683 8.35653 18.8487 8.3172 18.8362C7.90571 18.7048 7.50741 18.5409 7.12338 18.3432C7.08867 18.3253 7.06538 18.3324 7.03528 18.3504C6.34259 18.7675 5.64901 19.1836 4.95609 19.6007C4.76583 19.7153 4.56635 19.7426 4.36116 19.6539C4.28844 19.6225 4.21748 19.5745 4.16123 19.5186C3.56388 18.9248 2.96939 18.3282 2.37446 17.7318C2.25077 17.6084 2.19079 17.4577 2.19057 17.3411ZM10.8573 7.86742C9.11426 7.86676 7.70052 9.28203 7.70096 11.0264C7.7014 12.7723 9.11316 14.1865 10.8562 14.1871C12.5964 14.1878 14.0104 12.7745 14.0119 11.0328C14.0135 9.28246 12.6037 7.86786 10.8573 7.86742Z"
            :fill="walkingPoints < 600 ? '#DCDCDC' : '#666'"
          />
        </svg>
      </div>

      <div class="poi__header__button" @click="handlePoiLike" v-else>
        <svg
          height="28.15"
          viewBox="0 0 23 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="company-like"
          :class="{ liked: isLiked }"
          style="margin-top: 6px"
        >
          <path
            id="company-like"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.9449 0.0237897C15.101 -0.009136 13.7718 0.309092 12.6735 0.984788C12.3502 1.18369 12.0624 1.44719 11.7582 1.67122C11.655 1.74718 11.6123 1.87467 11.4765 1.92291C11.2517 1.60042 10.8436 1.36919 10.5143 1.14495C9.88061 0.713466 9.18963 0.419447 8.33163 0.183956C8.02965 0.101081 7.74612 0.139544 7.41633 0.0695515C7.07891 -0.00206579 6.46314 -0.0321313 6.10204 0.0466706H5.72653L4.88163 0.161075C2.45673 0.800437 1.03817 2.23562 0.281631 4.50845C0.0929146 5.07542 0.000209808 5.68506 0 6.45333V7.18552C0.160273 7.87195 0.198786 8.52128 0.445917 9.10752C0.939127 10.2774 1.54076 11.2734 2.25306 12.2193C2.49763 12.5441 2.79973 12.8332 3.05102 13.1574L3.26225 13.3405C3.64599 13.835 4.21003 14.3853 4.71735 14.7591C4.945 14.9268 5.12217 15.1854 5.35102 15.354C5.89528 15.7549 6.38891 16.198 6.94694 16.5896C7.31168 16.8455 7.6578 17.1595 8.02653 17.4133C8.81144 17.9535 9.5994 18.4643 10.4204 18.9692C10.6978 19.1398 10.9773 19.3189 11.2653 19.4955C11.3447 19.5441 11.4371 19.658 11.5235 19.6327C11.8159 19.5465 12.2473 19.1769 12.5092 19.015C13.4109 18.4573 14.2598 17.8643 15.1143 17.276C15.932 16.7131 16.6707 16.0938 17.4612 15.5142C17.7483 15.3037 17.9745 14.9919 18.2592 14.782C18.7833 14.3955 19.3651 13.8288 19.7612 13.3176C20.0291 12.9719 20.408 12.6667 20.6765 12.3108C21.3554 11.4111 21.9914 10.4631 22.4602 9.35921C22.7381 8.70481 22.8195 8.00788 23 7.23128V6.11012C23 5.04567 22.5777 3.79058 22.1551 3.11271C21.3644 1.84454 20.3325 0.960901 18.8459 0.367003C18.4527 0.209903 18.0025 0.169633 17.5551 0.0695515C17.3708 0.0283658 17.0897 0.111996 16.9449 0.0237897ZM13.4949 4.98895C13.6257 5.06821 13.8179 5.04794 13.9408 5.12624C14.1809 5.27915 14.3903 5.58697 14.4806 5.88131C14.7846 6.87157 14.2336 7.83483 13.6592 8.21516C13.4829 8.33185 13.1665 8.5441 12.7908 8.44397C12.1815 8.28151 11.6629 7.45348 11.899 6.56773C12.1017 5.80724 12.5344 5.00053 13.4949 4.98895ZM9.34082 4.98895C9.44453 5.05116 9.60334 5.03373 9.71633 5.08047C9.90204 5.15728 10.1633 5.34086 10.2796 5.49233C10.4845 5.75476 10.6431 6.0486 10.749 6.3618C11.0523 7.29052 10.6264 8.26941 9.90408 8.44397C9.44385 8.55519 9.12886 8.27666 8.91837 8.12364C8.0181 7.46924 7.67177 5.0113 9.34082 4.98895ZM6.71224 7.82618C6.80204 7.88073 6.93255 7.8549 7.04082 7.89483C7.1901 7.95519 7.33183 8.03196 7.46326 8.12364C8.10985 8.57926 8.82787 10.3712 7.58061 10.7321C7.27462 10.8206 6.97168 10.6909 6.78265 10.5948C6.2586 10.328 5.92909 9.89004 5.75 9.29056C5.50977 8.48655 6.00915 7.83474 6.71224 7.82618ZM16.2643 7.84906C16.3475 7.90531 16.4589 7.91039 16.5459 7.96347C16.7501 8.08792 16.903 8.34677 16.9684 8.60414C17.1898 9.47608 16.4305 10.3324 15.9122 10.5948C15.6714 10.7167 15.2967 10.822 14.9735 10.6863C14.5211 10.4964 14.2976 9.79053 14.5041 9.17616C14.7465 8.45463 15.2551 7.83412 16.2643 7.84906ZM11.6173 9.15328C11.6928 9.20055 11.8065 9.18909 11.899 9.22192C12.1342 9.30539 12.3942 9.39508 12.6031 9.51937C13.6756 10.1578 14.499 11.0629 14.9031 12.3566C15.0761 12.9106 15.1926 13.9587 14.8327 14.4159C14.6824 14.6067 14.2444 14.6367 13.9408 14.5532C13.5176 14.4368 13.0836 14.2944 12.6735 14.1642C12.361 14.065 12.0204 14.0549 11.6878 13.9812C11.421 13.922 11.0005 13.978 10.7959 14.0269C10.1727 14.1761 9.66178 14.2454 9.10612 14.4388C8.82271 14.5374 8.27977 14.7039 7.97959 14.5074C7.45702 14.1654 7.62051 12.7158 7.83877 12.1507C8.3429 10.8452 9.46105 9.61627 10.8663 9.19904C11.0806 9.13541 11.3482 9.15287 11.6173 9.15328Z"
          />
        </svg>
      </div>

      <div class="poi__header__content">
        <h1 class="poi__name">{{ selectedPoi.name }}</h1>
        <p class="poi__address">{{ selectedPoi.location }}</p>
        <div class="poi__header__content__rating">
          <ion-img
            v-for="n in 5"
            :key="n + '-rating'"
            :src="
              selectedPoi.rating >= n
                ? require('@/assets/images/icons/walk/paw_green.svg')
                : require('@/assets/images/icons/walk/paw_grey.svg')
            "
            alt="értékelés"
          />
        </div>
      </div>

      <div class="poi__header__button" @click="goToDestionation">
        <svg height="28.15" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15.9611 0.000574592C16.197 0.159007 16.2195 0.373121 16.167 0.635453C15.6473 3.25189 15.1351 5.86947 14.6228 8.48705C14.5876 8.66558 14.53 8.82286 14.3402 8.88256C14.1516 8.94168 14.0091 8.85443 13.881 8.72126C13.3428 8.16387 12.8023 7.60936 12.2468 7.03705C12.1649 7.13004 12.1211 7.17424 12.0836 7.22303C10.3583 9.47725 9.27499 12.0041 8.88217 14.8106C8.77141 15.6016 8.72584 16.4058 8.71084 17.2054C8.68373 18.6227 8.70335 20.0406 8.70335 21.4579C8.70335 21.8878 8.58856 21.9997 8.14959 21.9997C6.97688 21.9997 5.80417 22.0003 4.63147 21.9997C4.25133 21.9997 4.12847 21.8769 4.12847 21.498C4.12789 19.9516 4.12847 18.4052 4.12847 16.8587C4.12847 13.5649 4.98911 10.4853 6.47676 7.56401C7.15166 6.23857 7.96846 5.00268 8.94735 3.81042C8.7893 3.66749 8.62663 3.52914 8.47434 3.38104C8.12882 3.04638 7.79079 2.70484 7.44527 2.37018C7.31664 2.24561 7.24165 2.10727 7.29644 1.92989C7.34894 1.76055 7.48392 1.69224 7.6512 1.65838C9.66435 1.25024 11.6769 0.839234 13.6895 0.428801C14.3229 0.299644 14.9562 0.169913 15.589 0.0396083C15.6144 0.034442 15.6363 0.0137767 15.66 0C15.7592 0.000574031 15.8601 0.000574592 15.9611 0.000574592Z"
            fill="#666666"
          />
          <path
            d="M3.50203 13.104C3.18361 12.1448 2.88885 11.189 2.54967 10.2493C2.05071 8.86821 1.42484 7.54219 0.712452 6.25637C0.531903 5.93032 0.558438 5.80747 0.855508 5.58475C1.88343 4.8144 2.91192 4.04405 3.941 3.27485C4.20749 3.07566 4.41977 3.09575 4.59571 3.3753C5.12524 4.21741 5.63805 5.06984 6.16239 5.91539C6.24488 6.04857 6.23392 6.15247 6.15547 6.28564C5.08544 8.10245 4.26633 10.0237 3.7443 12.0673C3.65662 12.4123 3.58221 12.7613 3.50203 13.104Z"
            fill="#666666"
          />
        </svg>
      </div>
    </div>

    <div class="poi__images" v-if="selectedPoi.images?.length">
      <h1 class="title">Képek a helyről:</h1>
      <div class="poi__images__list">
        <div
          class="poi__images__list__item"
          v-for="image in selectedPoi.images"
          :key="image.id"
          :style="`background-image: url(${image.url});`"
          @click="openImage(image.url)"
        ></div>
      </div>
    </div>
    <div class="poi__about" v-if="selectedPoi.description">
      <h1 class="title">Információk:</h1>
      <p>{{ selectedPoi.description }}</p>
    </div>
    <div class="poi__pet__list" v-if="selectedPoi.editors?.length">
      <h1 class="title">Szerkesztők:</h1>
      <div class="poi__pet__list__list">
        <div
          class="poi__pet__list__list__item"
          v-for="pet in selectedPoi.editors"
          :key="pet.id"
          @click="goToPet(pet.id)"
        >
          <ion-img :src="pet.avatar" />
        </div>
      </div>
    </div>
    <div class="poi__pet__list" v-if="selectedPoi.pets?.length">
      <h1 class="title">Látogatók:</h1>
      <div class="poi__pet__list__list">
        <div class="poi__pet__list__list__item" v-for="pet in selectedPoi.pets" :key="pet.id" @click="goToPet(pet.id)">
          <ion-img :src="pet.avatar" />
        </div>
      </div>
    </div>
    <div class="poi__reviews">
      <h1 class="title" style="margin-bottom: 16px">Értékelések:</h1>

      <div class="poi__reviews__self">
        <ion-img
          :src="
            activePet?.avatar ??
            'https://res.cloudinary.com/doxocial/image/upload/w_280,h_280,c_fill/dfr2o6kimwlrs26sbm8t.png'
          "
          class="poi__reviews__self__avatar"
        />
        <div>
          <h2>{{ activePet?.name ?? 'Sushi' }}</h2>
          A Te értékelésed:
        </div>
        <div class="poi__reviews__self__paws" @click="goToReviewPage">
          <ion-img
            v-for="n in 5"
            :key="n + '-review'"
            :src="
              ownRating >= n
                ? require('@/assets/images/icons/walk/paw_green.svg')
                : require('@/assets/images/icons/walk/paw_grey.svg')
            "
            alt="értékelés"
          />
        </div>
      </div>

      <div class="poi__reviews__separator"></div>

      <template v-if="showReviews">
        <div v-for="(review, reviewKey) in reviews" :key="review.id" class="poi__reviews__list">
          <PoiReview :reviewData="review" :poiData="selectedPoi" />
          <div class="poi__reviews__separator" v-if="reviewKey < reviews.length - 1"></div>
        </div>
      </template>

      <h1 style="color: #a0a0a0; margin-top: 20px" v-if="false">Mutass többet</h1>
    </div>

    <PoiBusinessHours :data="selectedPoi.business_hours" v-if="selectedPoi.business_hours" />

    <div
      v-if="selectedPoi.email || selectedPoi.phone_number || selectedPoi.website"
      :style="'display: flex; justify-content: center; margin-top: 25px;'"
    >
      <a
        class="poi__header__button"
        :href="`tel:${selectedPoi.phone_number}`"
        v-if="selectedPoi.phone_number"
        :style="(selectedPoi.website || selectedPoi.email) && 'margin-right: 16px;'"
        @click="handlePoiContact"
      >
        <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.1176 8.54141L7.79327 7.04766C8.25146 6.63843 8.57349 6.10531 8.71805 5.51674C8.86261 4.92817 8.8231 4.31099 8.60459 3.74442L7.89001 1.88786C7.62304 1.19475 7.09452 0.626752 6.41213 0.299574C5.72973 -0.0276034 4.94481 -0.0893409 4.21726 0.12694C1.53993 0.923908 -0.518001 3.34517 0.115447 6.22033C0.532025 8.1118 1.3293 10.486 2.83959 13.012C4.353 15.5441 6.08172 17.4143 7.56392 18.7289C9.80127 20.71 12.9997 20.2151 15.0576 18.3479C15.6093 17.8475 15.944 17.1612 15.9936 16.4289C16.0432 15.6967 15.8039 14.9736 15.3244 14.4071L14.0139 12.8587C13.6186 12.3905 13.0884 12.048 12.4914 11.8754C11.8944 11.7028 11.258 11.708 10.6641 11.8902L8.49849 12.5536C7.93923 11.992 7.44914 11.369 7.03813 10.697C6.64142 10.0175 6.33225 9.29298 6.1176 8.53989V8.54141Z"
            fill="black"
          />
        </svg>
      </a>

      <div
        class="poi__header__button"
        v-if="selectedPoi.website"
        :style="selectedPoi.email && 'margin-right: 16px;'"
        @click="handlePoiWebView"
      >
        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20.0113 9.99998C20.0398 15.441 15.5435 19.9828 10.1138 19.9999C4.54185 20.0227 0.0171233 15.5776 4.88387e-05 10.0683C-0.0170256 4.51909 4.4451 0.0171232 9.98291 4.87767e-05C15.5093 -0.0170257 19.9885 4.45079 20.0113 9.99998ZM11.9977 4.4394C11.235 4.45079 10.5691 4.59877 10.0057 5.01424C9.56743 5.33297 9.18041 5.72568 8.7877 6.10132C8.41775 6.45988 8.42344 7.02334 8.77631 7.3819C9.13488 7.74615 9.69264 7.74615 10.074 7.37621C10.2675 7.18839 10.4553 6.99488 10.6488 6.80706C11.4001 6.08424 12.5213 6.07855 13.2327 6.79568C13.9499 7.5128 13.9442 8.62833 13.2214 9.37961C13.0278 9.57881 12.8286 9.76663 12.6351 9.96583C12.2823 10.3301 12.2823 10.8765 12.6238 11.2293C12.9709 11.5879 13.5401 11.5993 13.9043 11.2521C14.132 11.0358 14.3597 10.8252 14.5702 10.5919C15.6118 9.43083 15.8622 8.10472 15.2817 6.65908C14.741 5.30451 13.3864 4.43371 11.9977 4.4394ZM8.08195 15.5719C9.03812 15.5549 9.87477 15.2361 10.5748 14.5816C10.8025 14.3653 11.0188 14.1434 11.235 13.9157C11.5993 13.5401 11.5993 12.9709 11.235 12.6181C10.8708 12.2652 10.3244 12.2709 9.95445 12.6351C9.76094 12.823 9.57312 13.0165 9.37961 13.2043C8.63403 13.9271 7.5128 13.9328 6.79568 13.2214C6.07855 12.5042 6.07855 11.383 6.80137 10.6374C6.99488 10.4382 7.19408 10.2504 7.38759 10.0512C7.74615 9.68126 7.74615 9.12349 7.38759 8.77062C7.03472 8.41775 6.47695 8.41775 6.10701 8.77631C5.88504 8.9869 5.66307 9.19748 5.45818 9.42514C4.41095 10.5862 4.16052 11.9066 4.74105 13.3523C5.27605 14.7011 6.63062 15.5719 8.08195 15.5719ZM8.13318 11.0188C8.15594 11.3659 8.32669 11.6562 8.69094 11.8099C9.06089 11.9692 9.40807 11.8952 9.69264 11.6164C10.3415 10.9789 10.9846 10.3415 11.6164 9.69264C11.9863 9.31131 11.9749 8.75355 11.6107 8.39498C11.2521 8.0478 10.7 8.04211 10.3301 8.40637C9.68126 9.04381 9.04381 9.68695 8.40637 10.3301C8.22424 10.5008 8.13318 10.7171 8.13318 11.0188Z"
            fill="black"
          />
        </svg>
      </div>

      <a
        class="poi__header__button"
        :href="`mailto:${selectedPoi.email}`"
        v-if="selectedPoi.email"
        @click="handlePoiContact"
      >
        <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.21046 0H17.7895C19.2593 0 20 0.672807 20 2.04123V11.643C20 13 19.2593 13.6842 17.7895 13.6842H2.21046C0.740741 13.6842 0 13 0 11.643V2.04123C0 0.672807 0.740741 0 2.21046 0ZM9.99412 9.80702L17.9189 3.50088C18.2011 3.27281 18.4245 2.74825 18.0717 2.2807C17.7307 1.81316 17.1076 1.80175 16.6961 2.08684L9.99412 6.4886L3.30394 2.08684C2.89242 1.80175 2.26925 1.81316 1.92828 2.2807C1.57554 2.74825 1.79894 3.27281 2.08113 3.50088L9.99412 9.80702Z"
            fill="black"
          />
        </svg>
      </a>
    </div>

    <div class="share-box" @click="shareToSocial">
      <ion-button type="submit" id="submit" expand="full" shape="round" strong="true" class="btn submit">
        Helyszín&nbsp; megosztása
      </ion-button>
    </div>

    <h1 class="poi__report" @click="confirmPostReport">Valami nincs rendben, jelentem.</h1>
  </div>
</template>

<script>
import { IonImg, IonButton } from '@ionic/vue'
import { alertController, isPlatform, popoverController } from '@ionic/core'
import { defineComponent, toRefs, computed, ref, onMounted, watch } from 'vue'

import useAuth from '@/composables/auth'
import usePets from '@/composables/pets'
import useToast from '@/composables/toast'
import usePois from '@/composables/pois'
import useNavigation from '@/composables/navigation'
import useGeoLocation from '@/composables/geolocation'

import PoiReview from '@/components/Pet/Walk/PoiReview'
import PoiBusinessHours from '@/components/Pet/Walk/PoiBusinessHours'

import { PET_ROUTE, PAGE_POI_RATE_ROUTE, PAGE_POI_EDIT_ROUTE, LOGIN_ROUTE } from '@/constants/routes'
import { useRoute, useRouter } from 'vue-router'
import { Share } from '@capacitor/share'

export default defineComponent({
  name: 'PoiDetails',
  props: {
    selectedPoi: {},
  },
  components: {
    IonImg,
    IonButton,
    PoiReview,
    PoiBusinessHours,
  },
  setup(props) {
    const route = useRoute()
    const router = useRouter()
    const { isAuthenticated } = useAuth()
    const { activePet, PETS_STATE, getCurrentLeaderboard } = usePets()
    const { openToast } = useToast()
    const { navigateTo, openBrowserLink } = useNavigation()
    const { getPoi, visitPoi, contactPoi, webViewPoi, reportPoi, likePoi } = usePois()
    const { getCurrentPosition } = useGeoLocation()
    const selectedPoi = toRefs(props).selectedPoi
    const isLiked = ref(selectedPoi.value.is_liked)
    const ownRating = ref(selectedPoi.value.ownRating?.rating ?? 0)
    const alreadyReported = ref(false)
    const walkingPoints = ref(1)
    const showReviews = ref(true)

    const reviews = ref(selectedPoi.value.reviews ?? [])

    const poiType = computed(() => {
      if (selectedPoi.value.type === 'walkplace') {
        return 'Kutyafuttató'
      } else if (selectedPoi.value.type === 'dogbeach') {
        return 'Kutyastrand'
      } else if (selectedPoi.value.type === 'dogfriendly') {
        return 'Kutyabarát hely'
      } else if (selectedPoi.value.label !== undefined) {
        return selectedPoi.value.label
      }

      return 'Ismeretlen'
    })
    const petsWalking = computed(() => PETS_STATE.petsWalking)

    const getUserCoords = async () => {
      try {
        const res = await getCurrentPosition(null)
        return Promise.resolve(res)
      } catch (error) {
        return Promise.reject(error)
      }
    }

    const getDistanceBetweenTwoCoords = (coords1, coords2) => {
      const R = 6371e3 // metres
      const φ1 = (coords1.latitude * Math.PI) / 180
      const φ2 = (coords2.latitude * Math.PI) / 180
      const Δφ = ((coords2.latitude - coords1.latitude) * Math.PI) / 180
      const Δλ = ((coords2.longitude - coords1.longitude) * Math.PI) / 180

      const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

      return R * c
    }

    onMounted(async () => {
      if (!isAuthenticated.value) return

      try {
        const { total } = await getCurrentLeaderboard()
        walkingPoints.value = total
      } catch {
        console.error('Could not get total walking points')
      }

      try {
        const { coords } = await getUserCoords()

        if (coords.latitude && coords.longitude) {
          const distance = getDistanceBetweenTwoCoords(coords, {
            latitude: selectedPoi.value.latitude,
            longitude: selectedPoi.value.longitude,
          })

          if (distance > 300) return

          await visitPoi(selectedPoi.value.id, petsWalking.value)
        }
      } catch (error) {
        console.error(error)
      }
    })

    const getPoiDetails = async () => {
      showReviews.value = false
      const poi = await getPoi(selectedPoi.value.id)
      selectedPoi.value = poi
      ownRating.value = poi.ownRating?.rating ?? 0
      reviews.value = poi.reviews ?? []

      showReviews.value = true
    }

    const getCustomMarkerIcon = marker => {
      if (marker.logo) {
        return marker.logo
      }

      if (marker.type === 'walkplace') {
        return require('@/assets/images/icons/walk/walkplace-marker.svg')
      } else if (marker.type === 'dogbeach') {
        return require('@/assets/images/icons/walk/dogbeach-marker.svg')
      } else if (marker.type === 'dogfriendly') {
        return require('@/assets/images/icons/walk/dogfriendly-marker.svg')
      } else if (marker.type !== undefined) {
        return require(`@/assets/images/icons/walk/poi/${marker.type}.svg`)
      }

      return require('@/assets/images/icons/walk/unknown-marker.svg')
    }

    const goToDestionation = () => {
      const destination = selectedPoi.value.latitude + ', ' + selectedPoi.value.longitude

      if (isPlatform('ios')) {
        window.open(`maps://?q=${destination}`, '_system')
      } else {
        window.open(`geo:0,0://?q=${destination}`, '_system')
      }
    }

    const confirmPostReport = async () => {
      if (!isAuthenticated.value) return

      const dialog = await alertController.create({
        cssClass: 'confirm-dialog',
        message: `<img src="${require('@/assets/images/icons/exclamation-circle.svg')}" class="alert-icon" /><p class="ion-text-center">Kifogásolható tartalommal találkoztál? Jelentsd nekünk és megvizsgáljuk az esetet!</p>`,
        buttons: [
          {
            text: 'Tartalom jelentése',
            cssClass: 'btn btn-dark btn-block',
            handler: async () => {
              try {
                await popoverController.dismiss()
                await reportToAdmins()

                return Promise.resolve()
              } catch (error) {
                return Promise.reject(error)
              }
            },
          },
          {
            text: 'Mégse',
            role: 'cancel',
            cssClass: 'btn btn-link btn-block',
          },
        ],
      })

      return dialog.present()
    }

    const reportToAdmins = async () => {
      if (alreadyReported.value) {
        return
      }

      alreadyReported.value = true

      try {
        await reportPoi(selectedPoi.value.id)

        openToast({
          message: 'Sikeresen jelentetted ezt a helyet. Hamarosan átvizsgáljuk.',
          color: 'success',
        })
      } catch (error) {
        console.error(error)
        alreadyReported.value = false

        openToast({
          message: 'Sajnos nem sikerült jelenteni ezt a helyet :(',
          color: 'warning',
        })
      }
    }

    const goToReviewPage = async () => {
      if (!isAuthenticated.value) {
        return navigateTo({ name: LOGIN_ROUTE })
      }

      await navigateTo({ name: PAGE_POI_RATE_ROUTE, params: { id: selectedPoi.value.id } })
    }

    const goToEdit = async () => {
      // if (walkingPoints.value >= 600) {
      //   return await navigateTo({ name: PAGE_POI_EDIT_ROUTE, params: { id: selectedPoi.value.id } })
      // }

      return await navigateTo({ name: PAGE_POI_EDIT_ROUTE, params: { id: selectedPoi.value.id } })

      const icon = require(`@/assets/images/icons/sad-dog.png`)

      const poiName =
        selectedPoi.value.type === 'walkplace'
          ? 'kutyafuttató'
          : selectedPoi.value.type === 'dogbeach'
          ? 'kutyastrand'
          : 'kutyabarát hely'

      const dialog = await alertController.create({
        cssClass: 'confirm-dialog poi-dialog',
        message: `
          <div class="poi-info">
            <img src="${icon}" class="icon" />
            <p>Ezt a ${poiName} helyet csak Felfedező szinten tudod szerkeszteni!</p>
          </div>
        `,
        buttons: [
          {
            text: 'Bezárás',
            role: 'cancel',
            cssClass: 'btn btn-link btn-block btn-popup-close',
          },
        ],
      })

      await dialog.present()
    }

    const openImage = async url => {
      const dialog = await alertController.create({
        cssClass: 'poi-image-dialog',
        message: `<img src="${url}" class="poi-image-alert" />`,
      })

      await dialog.present()
    }

    const handlePoiLike = async () => {
      if (!isAuthenticated.value) return

      try {
        await likePoi(selectedPoi.value.id, !isLiked.value)
        isLiked.value = !isLiked.value
      } catch (error) {
        console.error(error)
      }
    }

    const handlePoiContact = async () => {
      if (!isAuthenticated.value) return

      contactPoi(selectedPoi.value.id, petsWalking.value)
    }

    const handlePoiWebView = async () => {
      openBrowserLink(selectedPoi.value.website)

      if (!isAuthenticated.value) return

      await webViewPoi(selectedPoi.value.id, petsWalking.value)
    }

    const goToPet = async petId => {
      await router.push({ name: PET_ROUTE, params: { id: petId } })
    }

    const shareToSocial = async () => {
      try {
        await Share.share({
          url: `https://doxocial.com/poi/${selectedPoi.value.slug}`,
        })
      } catch {}
    }

    watch(
      () => route.name,
      () => getPoiDetails(),
    )

    return {
      reviews,
      poiType,
      activePet,
      ownRating,
      walkingPoints,
      isLiked,
      goToEdit,
      getCustomMarkerIcon,
      goToDestionation,
      confirmPostReport,
      goToReviewPage,
      openImage,
      handlePoiLike,
      handlePoiContact,
      handlePoiWebView,
      showReviews,
      goToPet,
      shareToSocial,
      isAuthenticated,
    }
  },
})
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@900&family=Poppins:wght@800&display=swap');

.company-like {
  #company-like {
    fill: #dcdcdc;
    transition: 0.15s ease-in-out;
  }

  &.liked #company-like,
  &:hover #company-like {
    fill: #e6224a;
    transition: 0.15s ease-in-out;
  }
}

.scroll {
  overflow-y: auto;
  max-height: calc(100vh - 250px);
  padding-bottom: 110px;
}

h1 {
  font-weight: 700;
  font-size: 12px !important;
  text-align: left;
  margin: 0 34px 5px 34px;

  &.title {
    padding: 0 16px;
  }
}

.poi {
  &__icon {
    position: relative;
    top: -65px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 6;
    min-width: 75px;
    max-width: 75px;
    min-height: 75px;
    max-height: 75px;
    background: #fff;
    border-radius: 50%;

    display: flex;
    justify-content: center;
    align-items: center;

    .lottie-animation {
      max-width: 50px;
    }

    svg {
      max-height: 50px;
    }

    &:not(.vendor) ion-img::part(image) {
      min-height: 45px;
      max-height: 45px;
    }

    &.vendor {
      border: 5px solid #fff;

      ion-img::part(image) {
        border-radius: 9999px;
        object-fit: cover;
      }
    }
  }

  &__type {
    margin-top: -65px;
    font-size: 10px;
    color: #a6a6a6;
    position: relative;

    &:after {
      top: 20px;
      left: 0;
      position: absolute;
      width: 100%;
      height: 30px;
      content: '';
      z-index: 1;
      pointer-events: none;
      background: linear-gradient(white 0%, white 20%, transparent 100%);
    }
  }

  &__name {
    margin-top: 30px;
    font-weight: 900;
    text-align: center;
    font-size: 16px !important;
    letter-spacing: -0.3px;
    font-family: 'Montserrat', sans-serif;
    margin: 15px 5px 2px;
  }

  &__address {
    margin-top: 0;
    margin-bottom: 6px;
  }

  &__header {
    display: flex;
    align-items: center;
    padding: 0 26px;
    margin-bottom: 34px;

    &__button {
      min-width: 60px;
      min-height: 60px;
      max-width: fit-content;
      border-radius: 9999px;

      display: flex;

      align-items: center;
      justify-content: center;

      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
    }

    &__content {
      flex-grow: 1;

      &__rating {
        display: flex;
        justify-content: center;

        ion-img {
          margin: 0 1.5px;
          min-width: 14px;
        }

        &__title {
          font-size: 10px;
          font-weight: 400;
        }
      }
    }
  }

  &__images {
    margin-bottom: 8px;

    &__list {
      display: flex;
      overflow-x: auto;
      white-space: nowrap;
      padding: 0 26px 27px 26px;

      &__item {
        min-width: 140px;
        aspect-ratio: 1 / 1;

        background-position: center center;
        background-size: cover;
        border-radius: 25px;
        box-shadow: -7px 11px 29px -10px rgba(0, 0, 0, 0.2);

        margin-right: 16px;

        &:last-of-type {
          margin-right: 0;
        }
      }
    }
  }

  &__about {
    text-align: left;
    padding: 0 34px;
    margin-bottom: 35px;

    h1 {
      font-weight: 700;
      font-size: 12px !important;
      text-align: left;
      margin: 0 0 5px 0;
    }

    p {
      margin: 0;
      font-size: 12px;
    }
  }

  &__pet__list {
    margin-bottom: 35px;
    padding: 0 34px;

    h1 {
      margin: 0 0 5px 0;
    }

    &__list {
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-end;
      padding-left: 10px;

      &__item {
        min-width: 52px;
        min-height: 52px;
        max-width: 52px;
        max-height: 52px;
        border-radius: 9999px;
        margin-left: -10px;

        border: 5px solid #fff;
        filter: drop-shadow(3px 1px 5px rgba(0, 0, 0, 0.2));

        ion-img::part(image) {
          border-radius: 9999px;
        }
      }
    }
  }

  &__reviews {
    padding: 0 34px;

    h1 {
      margin: 0 0 5px 0;
    }

    &__self {
      display: flex;
      align-items: center;
      font-size: 9px;
      font-weight: 600;
      line-height: 16px;

      &__avatar {
        aspect-ratio: 1 / 1;
        margin-right: 10px;
        border-radius: 9999px;
        width: 40px;
        height: 40px;
        min-width: 40px;
        min-height: 40px;

        border: 3px solid #fff;
        filter: drop-shadow(3px 1px 5px rgba(0, 0, 0, 0.2));

        &::part(image) {
          border-radius: 9999px;
        }
      }

      h2 {
        margin: 0;
        font-weight: 800;
        text-align: left;
        font-size: 11px !important;
        font-family: 'Poppins', sans-serif;
        line-height: 12px;
      }

      &__paws {
        flex-grow: 1;
        display: flex;
        justify-content: end;

        ion-img {
          width: 23px;
          height: 21px;
          margin-right: 5px;

          &:last-of-type {
            margin-right: 0;
          }
        }
      }

      &.column {
        flex-direction: column;

        .avatar {
          margin-right: 0;
          margin-bottom: 9px;

          &::part(image) {
            border-radius: 9999px;
            min-width: 50px;
            min-height: 50px;
            max-width: 50px;
          }
        }

        h2 {
          font-size: 13px !important;
          font-weight: 700;
          text-align: center;
          line-height: 16px;
          margin-bottom: 10px;
          font-family: 'Open Sans', sans-serif;
        }
      }
    }

    &__separator {
      margin: 8px 0;
      height: 1px;
      width: 100%;

      opacity: 0.6;
      background: linear-gradient(90deg, rgba(196, 196, 196, 0) 0.07%, #c4c4c4 51.56%, rgba(196, 196, 196, 0) 100%);
    }
  }

  &__report {
    margin-top: 22px;
    margin-bottom: 30px;
    color: #c8c8c8;
    text-align: center;
  }
}

.share-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 50px;

  p {
    margin: 0;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: -0.3px;
    line-height: 19px;
    color: #e6224a;
    margin-right: 7px;
  }
}

.submit {
  --background: #333;
  --box-shadow: none;
  height: 50px;
  max-width: 274px;
  margin: 0 auto;
  font-size: 16px;
  letter-spacing: -0.64px;
  font-weight: 900;
}
</style>
